import { render } from "./ProfileCardDate.vue?vue&type=template&id=7439f314&scoped=true"
import script from "./ProfileCardDate.vue?vue&type=script&lang=ts"
export * from "./ProfileCardDate.vue?vue&type=script&lang=ts"

import "./ProfileCardDate.vue?vue&type=style&index=0&id=7439f314&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7439f314"

export default script